import React from 'react'
import Layout from '../../../../component/layout/Layout'
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const PilotScale = () => {

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000
    };

    // 🔥 Replace with actual images
    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FbioEngineering%2F2.png?alt=media&token=9ef1763b-1706-459d-b364-f0d42e7bd3c2',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FbioEngineering%2F2.png?alt=media&token=9ef1763b-1706-459d-b364-f0d42e7bd3c2'
    ];

    return (
        <Layout>
            {/* BREADCRUMB */}
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/">Bio-Engineering Instruments</a></li>
                </ul>
            </div>

            {/* TITLE */}
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Pilot In-Situ Sterilizable Fermentation System </h1>
                </div>
            </div>

            {/* MAIN SECTION */}
            <section
                id="portfolio-details"
                className="portfolio-details"
                style={{ backgroundColor: 'white', marginBottom: '12rem' }}
            >
                <div className="container">
                    <div className="row gy-4">

                        {/* IMAGE SLIDER */}
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ textAlign: 'center' }}>
                                                <img
                                                    src={src}
                                                    alt="Labscale Model"
                                                    className="responsive"
                                                    style={{ maxHeight: '400px', objectFit: 'contain' }}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>

                        {/* DESCRIPTION */}
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Pilot In-Situ Sterilizable Fermentation System</h3>

                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                   Unlock scalable fermentation with our robust system offering vessel volumes from 30L to 1,000L, driven by AC motors with top or bottom drive options (mechanical seal or magnetic coupling) delivering 30–1,000 rpm. Crafted from SUS316L/SUS304 with electrolytic polishing for superior hygiene, it ensures reliable sterilization via heat exchanger or steam injection at 105–130℃. Aeration is optimized with a stainless-steel ring sparger and 0.2 μm inlet/outlet filters, while integrated sensors monitor pH, DO, temperature, anti-foam, and pressure control. A 20-inch touch screen PLC controller provides intuitive operation, with automatic data storage of key parameters including pH, DO, temperature, foam, pressure, and agitation speed—making this system the perfect choice for precision, efficiency, and large-scale fermentation success.

                                    <br /><br />

                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Labscale Fermenter Model"
                                        style={{
                                            color: '#0d6efd',
                                            fontWeight: '600',
                                            textDecoration: 'underline'
                                        }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <br />
        </Layout>
    )
}

export default PilotScale